module.exports = __webpack_public_path__ + "static/media/jimy.d51a1bdc.jpg";